export default {
  parts: ['tab', 'tablist'],
  variants: {
    enclosed: {
      tab: {
        bg: 'gray.100',
        borderTopRadius: '0',
        borderBottomColor: 'gray.500',
        color: 'gray.700',
        marginRight: '0.25em',
        _selected: {
          bg: 'transparent',
          borderTopRadius: 'md',
          color: 'black',
          fontWeight: 'semibold',
        },
      },
      tablist: {
        mb: '-1px',
        borderBottom: '1px solid',
        borderColor: 'gray.500',
      },
    },
  },
  defaultProps: {
    variant: 'enclosed',
  },
}
